import { render, staticRenderFns } from "./BotonesRedesSociales.vue?vue&type=template&id=e3f11c90&scoped=true"
import script from "./BotonesRedesSociales.vue?vue&type=script&lang=js"
export * from "./BotonesRedesSociales.vue?vue&type=script&lang=js"
import style0 from "./BotonesRedesSociales.vue?vue&type=style&index=0&id=e3f11c90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f11c90",
  null
  
)

export default component.exports